import styled from 'styled-components'
import { AutoComplete as YogaAutocomplete } from '@gympass/yoga'

export default styled(YogaAutocomplete)`
  flex: 1;

  fieldset,
  ul {
    border: 0;
  }

  ul {
    box-shadow: 0px 2px 6px rgba(152, 152, 167, 0.25);
  }

  input {
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 24px;
  }

  fieldset legend span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`
